<template>
    <div>
        <v-data-table calculate-widths :headers="header_formulas" :items="busqueda_items"
            loading-text="Loading... Please wait" item-key="cod_formula" show-expand :single-expand=true
            @item-expanded="loadDetails">
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <v-row class="mt-0">
                        <v-col v-for="check in checkitems" v-bind:key="check">
                            <v-simple-checkbox v-if="item[check] == null" indeterminate v-model="item[check]" disabled>
                            </v-simple-checkbox>
                            <v-simple-checkbox v-else v-model="item[check]" :label="check"
                                :color="item[check] ? 'green' : 'red'" off-icon="mdi-close-box-outline">
                            </v-simple-checkbox>
                            {{ check }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-title>Color</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <p class="text-capitalize">{{ item.color }}</p>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-title>Proceso</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <p class="text-capitalize">{{ item.proceso }}</p>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-title>Temperatura de Servicio</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <p class="text-capitalize">{{ item.temp_servicio }}</p>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-title>Densidad</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <p class="text-capitalize">{{ item.densidad }}</p>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                    <v-row class="mb-0">
                        <v-col>
                            <Postcurado :key="sinpostKey" title="Sin Postcurado" icon="mdi-chart-donut"
                                v-if="item.sinpostcurado" :formula="item.sinpostcurado" />
                        </v-col>
                        <v-col>
                            <Postcurado :key="conpostKey" title="Con Postcurado" icon="mdi-chart-donut-variant"
                                v-if="item.postcurado" :formula="item.postcurado" />
                        </v-col>
                    </v-row>
                </td>
            </template>

            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-btn color="success" large class="ma-2">
                        <downloadexcel :data="busqueda_items" :fields="json_fields">
                            <v-icon left>mdi-download</v-icon>
                            Descargar Excel
                        </downloadexcel>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </template>

            <template v-slot:item.fiable="{ item }">
                <v-icon v-if="item.fiable" color="success">mdi-shield-check</v-icon>
                <v-icon v-else-if="!item.fiable" color="error">mdi-shield-off</v-icon>
            </template>

            <template v-slot:item.cod_formula="{ item }">
                <router-link :to="'/formulas/' + item.cod_formula">{{
                    item.cod_formula
                }}</router-link>
            </template>

            <template v-slot:item.formula_base="{ item }">
                <div class="text--primary" v-for="base in item.formula_base" :key="base.id" fluid>
                    <router-link :to="'/bases/' + base.cod_base.cod_base">{{ base.cod_base.cod_base }}</router-link>
                    ({{ base.cod_base.descripcion }}) [{{ base.ppc }} ppc]
                </div>
            </template>

            <template v-slot:item.formula_aditivo="{ item }">
                <div class="text--primary" v-for="aditivo in item.formula_aditivo" :key="aditivo.id" fluid>
                    <router-link :to="'/aditivos/' + aditivo.cod_aditivo.cod_aditivo">{{
                        aditivo.cod_aditivo.cod_aditivo
                    }}</router-link>
                    ({{ aditivo.cod_aditivo.descripcion }}) [{{ aditivo.ppc }}
                    ppc]
                </div>
            </template>

            <template v-slot:item.precio="{ item }">
                <v-chip>{{ item.precio }} €/Kg</v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2"
                    @click="$router.push({ name: 'FormulaId', params: { id: item.cod_formula } })">mdi-eye
                </v-icon>
                <v-icon small @click="showDeleteFormulaDialog(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogDeleteFormula" persistent max-width="500px">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.cod_formula }}
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar la fórmula?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDeleteFormula = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteFormula(itemToDelete.cod_formula)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Postcurado from "@/components/Postcurado.vue";
import FormulasDataService from "@/services/FormulasDataService";
import downloadexcel from "vue-json-excel";
export default {
    props: {
        title: String,
        busqueda: Array,
    },
    data() {
        return {
            busqueda_items: this.busqueda,
            header_formulas: [
                { text: "Fiable", value: "fiable", sortable: false },
                { text: "Código", value: "cod_formula" },
                { text: "Descripción", value: "descripcion" },
                { text: "Bases", value: "formula_base" },
                { text: "Aditivos", value: "formula_aditivo" },
                { text: '€/Kg', value: "precio" },

                { text: "Actions", value: "actions", sortable: false },
            ],
            checkitems: ['esponja', 'aceite', 'cables', 'desmoldeo', 'fda', 'fuego', 'grasa', 'green_strength'],
            dialogDeleteFormula: false,
            itemToDelete: {},
            procesos: [
                { name: "Autoclave", abbr: "AC", value: "autoclave" },
                { name: "Calandra", abbr: "C", value: "calandra" },
                { name: "Extrusion", abbr: "E", value: "extrusion" },
                { name: "Moldeo", abbr: "M", value: "moldeo" },
            ],
            sinpostKey: 0,
            conpostKey: 0,
            json_fields: {
                "Codigo Formula": "cod_formula",
                "Descripcion": "descripcion",
                "cliente": "cliente",
                "especificacion": "especificacion",
                "Bases": {
                    field: "formula_base",
                    callback: (items) => {
                        let str_bases = '';
                        for (const element of items) {
                            if (str_bases != '') {
                                str_bases += ", "
                            }
                            str_bases += element.cod_base.cod_base;
                            if (element.cod_base.descripcion != "") {
                                str_bases += " (" + element.cod_base.descripcion + ")";
                            }
                            if (element.ppc != "") {
                                str_bases += " [" + element.ppc + " ppc]";
                            }
                        }
                        return str_bases
                    },
                },
                "Aditivos": {
                    field: "formula_aditivo",
                    callback: (items) => {
                        let str_aditivos = '';
                        for (const element of items) {
                            if (str_aditivos != '') {
                                str_aditivos += ", "
                            }
                            str_aditivos += element.cod_aditivo.cod_aditivo;
                            if (element.cod_aditivo.descripcion != "") {
                                str_aditivos += " (" + element.cod_aditivo.descripcion + ")";
                            }
                            if (element.ppc != "") {
                                str_aditivos += " [" + element.ppc + " ppc]";
                            }
                        }
                        return str_aditivos
                    },
                },
                "Proceso": "proceso",
                "Platino": "platino",
                "Esponja": "esponja",
                "FDA": "fda",
                "Color": {
                    field: "id_color",
                    callback: (item) => {
                        let str_color = item.nombre;
                        if (item.ral != "") {
                            str_color += " (" + item.ral + ")";
                        }
                        if (item.referencia != "") {
                            str_color += " [" + item.referencia + "]";
                        }
                        return str_color;
                    },
                },
                "Densidad": "densidad",
                "Postcurado Valor": "postcurado_valor",
                "Postcurado Dureza": "postcurado_dureza",
                "Postcurado Alargamiento": "postcurado_alargamiento",
                "Postcurado Carga Rot.mpa": "postcurado_carga_rot_mpa",
                "Postcurado Desgarro": "postcurado_desgarro",
                "Postcurado C-Set": "postcurado_c_set",
                "Sin Postcurado Valor": "sinpostcurado_valor",
                "Sin Postcurado Dureza": "sinpostcurado_dureza",
                "Sin Postcurado Alargamiento": "sinpostcurado_alargamiento",
                "Sin Postcurado Carga Rot.mpa": "sinpostcurado_carga_rot_mpa",
                "Sin Postcurado Desgarro": "sinpostcurado_desgarro",
                "Sin Postcurado C-Set": "sinpostcurado_c_set",
                "Aceite": "aceite",
                "Grasa": "grasa",
                "Fuego": "fuego",
                "Green Strength": "green_strength",
                "Desmoldeo": "desmoldeo",
                "Fiable": "fiable",
                "Aplicaciones": {
                    field: "formula_aplicacion",
                    callback: (items) => {
                        let str_aplicaciones = '';
                        for (const element of items) {
                            if (str_aplicaciones != '') {
                                str_aplicaciones += ", "
                            }
                            str_aplicaciones += element.id_aplicacion.nombre;
                            if (element.id_aplicacion.comentario != "") {
                                str_aplicaciones += " (" + element.id_aplicacion.comentario + ")";
                            }
                        }
                        return str_aplicaciones
                    },
                },
                "Precio": "precio",
            },
        }
    },
    methods: {
        loadDetails({ item }) {
            let postcurado_dict = {
                valor: item.postcurado_valor,
                alargamiento: item.postcurado_alargamiento,
                c_set: item.postcurado_c_set,
                carga_rot_mpa: item.postcurado_carga_rot_mpa,
                desgarro: item.postcurado_desgarro,
                dureza: item.postcurado_dureza,
            }
            item['postcurado'] = postcurado_dict;
            let sinpostcurado_dict = {
                valor: item.sinpostcurado_valor,
                alargamiento: item.sinpostcurado_alargamiento,
                c_set: item.sinpostcurado_c_set,
                carga_rot_mpa: item.sinpostcurado_carga_rot_mpa,
                desgarro: item.sinpostcurado_desgarro,
                dureza: item.sinpostcurado_dureza,
            }
            item['sinpostcurado'] = sinpostcurado_dict;
            this.sinpostKey += 1;
            this.conpostKey += 1;
            item.color = item.id_color ? item.id_color.nombre + " (" + item.id_color.ral + ") " + item.id_color.referencia : "";

            item.proceso = this.procesos
                .filter((proceso) => proceso.value == item.proceso)
                .map(p => p.name)[0]

        },
        showDeleteFormulaDialog(item) {
            this.itemToDelete = item
            this.dialogDeleteFormula = !this.dialogDeleteFormula
        },
        deleteFormula(id) {
            FormulasDataService.delete(id)
                .then(() => {
                    this.$router.go();
                    this.dialogDelete = false;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    },
    components: { Postcurado, downloadexcel }
}
</script>